module.exports = __webpack_public_path__ + "static/img/10.c3a96ef.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10.jpeg
// module id = XJOD
// module chunks = 0